module.exports = __webpack_public_path__ + "static/media/pustoparan-1.bd5e1de7.png";